export default "__VITE_ASSET__a2a27819__"